import { z } from 'zod';
import { ISOCountryVO, ISOSubdivisionVO, CoordinatesVO, } from "../../../../common/validators/value-objects.js";
export const BaseAddressDTOSchema = z.object({
    id: z.string().uuid(),
    countryId: ISOCountryVO,
    subdivisionId: ISOSubdivisionVO.nullable(),
    premiseNumber: z.string().max(6).nullable(),
    thoroughfare: z.string().max(60).nullable(),
    premise: z.string().max(60).nullable(),
    subPremise: z.string().max(30).nullable(),
    poBox: z.string().max(10).nullable(),
    locality: z.string().max(30).nullable(),
    postcode: z.string().min(3).max(10).nullable(),
    coordinates: CoordinatesVO.nullable(),
    createdAt: z.string(),
    updatedAt: z.string(),
    deletedAt: z.string().nullable(),
    isDeleted: z.boolean(),
});
//# sourceMappingURL=addresses.dto.js.map